import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CohortModalComponent } from 'src/app/cohorts/cohort-modal/cohort-modal.component';
import { CohortService } from 'src/app/cohorts/services/cohort.service';

@Component({
  selector: 'dcc-cohorts-modal-renderer',
  template: `
    <span *ngIf="!cohortName || cohortName === 'N/A'" style="link-style">{{
      cohortName || 'N/A'
    }}</span>
    <a
      *ngIf="cohortName && cohortName !== 'N/A'"
      href="#"
      (click)="handleClick($event)"
      >{{ cohortName }}</a
    >
  `,
  styleUrls: ['./cohorts-modal-renderer.component.scss'],
})
export class CohortsModalRendererComponent implements ICellRendererAngularComp {
  cohortName: string;

  private params: any;

  constructor(
    private modalService: NgbModal,
    private cohortService: CohortService,
  ) {}

  agInit(params: any) {
    this.params = params;
    this.cohortName = this.params.data.cohort;
  }

  handleClick(event: Event) {
    event.preventDefault();
    this.openModal();
  }

  async openModal() {
    const cohort = await this.cohortService.getCohort(this.params.data.cohort);
    const modal = this.modalService.open(CohortModalComponent, {
      size: 'lg',
      windowClass: 'lytxModal',
      centered: true,
    });
    modal.componentInstance.cohort = cohort;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
